import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _excluded = ["product"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import QS from 'qs';
import Base from './base';
import { AutomationItem, ShareLink } from '../models';
import { CANCEL_KEYS } from '../utils/consts';

/**
 * `Service` The share service
 */
var Share = /*#__PURE__*/function (_Base) {
  /**
   * Create the project service instance.
   *
   * @param sdk - the SDK instance
   */
  function Share(sdk) {
    _classCallCheck(this, Share);
    return _callSuper(this, Share, [sdk]);
  }

  /**
   * Static getter of the class name
   *
   * @returns The detail property name used by SDK instance.
   */
  _inherits(Share, _Base);
  return _createClass(Share, [{
    key: "getSharedStatus",
    value: (
    /**
     * Get document shared status
     * https://platform.stoplight.autodesk.com/docs/docs-cp/reference/B360-Docs-V2.yaml/paths/~1projects~1%7BprojectId%7D~1shared-status:check/post
     *
     * @param projectId - the project id
     * @param payload - the request body, containing list of entities urn, shape of \{ resources \}
     * @param config - Configurable object to overwrite request parameters.
     * @returns a promise with shared status, shape of
     *                    \{
     *                      results: \{ shared: boolean, id: string \}[],
     *                      errors: \{ id: string, error: \{ code: string, title: string, detail: string \} \}[]
     *                    \}
     */
    function () {
      var _getSharedStatus = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(projectId, payload, config) {
        var url, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              url = "/projects/".concat(projectId, "/shared-status:check");
              _context.next = 3;
              return this.HttpService.dmV2.post(url, payload, config);
            case 3:
              response = _context.sent;
              return _context.abrupt("return", response.data || {});
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getSharedStatus(_x, _x2, _x3) {
        return _getSharedStatus.apply(this, arguments);
      }
      return getSharedStatus;
    }()
    /**
     * Create document shared links
     * https://platform.stoplight.autodesk.com/docs/docs-cp/reference/B360-Docs-V2.yaml/paths/~1projects~1%7BprojectId%7D~1shared:batch-create/post
     *
     * @param projectId - the project id
     * @param payload - the resources to create link, shape or
     *                          \{
     *                            type: 'Public'|'AccountDirectory',
     *                            resources: \{urn: string, parentFolder: string\}[],
     *                            parentFolder: string,
     *                            recipients: \{emails?: string[], userIds?: string[], companyOxygenIds?: string[], roleOxygenIds?:string[]\}
     *                            title: string,
     *                            message: string,
     *                            expirationDate: string
     *                          \}
     * @param config - Configurable object to overwrite request parameters
     */
    )
  }, {
    key: "createSharedLinks",
    value: (function () {
      var _createSharedLinks = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(projectId, payload, config) {
        var _this = this;
        var conf, url, response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              conf = _extends(_defineProperty({}, CANCEL_KEYS, {
                getter: function getter() {
                  return _this.createLinksCancelToken;
                },
                setter: function setter(token) {
                  return _this.createLinksCancelToken = token;
                },
                clearer: function clearer() {
                  return _this.createLinksCancelToken = undefined;
                }
              }), config);
              url = "/projects/".concat(projectId, "/shared:batch-create");
              _context2.next = 4;
              return this.HttpService.dmV2.post(url, payload, conf);
            case 4:
              response = _context2.sent;
              return _context2.abrupt("return", response.data || {});
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function createSharedLinks(_x4, _x5, _x6) {
        return _createSharedLinks.apply(this, arguments);
      }
      return createSharedLinks;
    }()
    /**
     * Delete shared link by shareId
     * https://platform.stoplight.autodesk.com/docs/docs-cp/reference/B360-Docs-V2.yaml/paths/~1projects~1%7BprojectId%7D~1shared~1%7BshareId%7D/delete
     *
     * @param projectId - the project id
     * @param shareId - the share id
     * @param config - Configurable object to overwrite request parameters
     */
    )
  }, {
    key: "deleteSharedLink",
    value: (function () {
      var _deleteSharedLink = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(projectId, shareId, config) {
        var url, response;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              url = "/projects/".concat(projectId, "/shared/").concat(shareId);
              _context3.next = 3;
              return this.HttpService.dmV2["delete"](url, config);
            case 3:
              response = _context3.sent;
              return _context3.abrupt("return", response.data || {});
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function deleteSharedLink(_x7, _x8, _x9) {
        return _deleteSharedLink.apply(this, arguments);
      }
      return deleteSharedLink;
    }()
    /**
     * Batch delete shared links
     * https://platform.stoplight.autodesk.com/docs/docs-cp/reference/B360-Docs-V2.yaml/paths/~1projects~1%7BprojectId%7D~1shared:batch-delete/post
     *
     * @param projectId - the project id
     * @param payload - the resources to be deleted, shape of \{ resources \}
     * @param config - Configurable object to overwrite request parameters
     */
    )
  }, {
    key: "deleteSharedLinks",
    value: (function () {
      var _deleteSharedLinks = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(projectId, payload, config) {
        var url, response;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              url = "/projects/".concat(projectId, "/shared:batch-delete");
              _context4.next = 3;
              return this.HttpService.dmV2.post(url, payload, config);
            case 3:
              response = _context4.sent;
              return _context4.abrupt("return", response.data || {});
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function deleteSharedLinks(_x10, _x11, _x12) {
        return _deleteSharedLinks.apply(this, arguments);
      }
      return deleteSharedLinks;
    }()
    /**
     * Create package shared links
     * https://platform.stoplight.autodesk.com/docs/acc-packages-service/9787c9b4f0a4f-batch-create-links
     *
     * @param projectId - the project id
     * @param payload - the resources to create link, shape or
     *                          \{
     *                            type: 'AccountDirectory',
     *                            resources: string[],
     *                            message: string,
     *                            recipients: \{userIds?: string[], companyOxygenIds?: string[], roleOxygenIds?:string[]\}
     *                          \}
     * @param config - Configurable object to overwrite request parameters
     */
    )
  }, {
    key: "createPackageSharedLinks",
    value: (function () {
      var _createPackageSharedLinks = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(projectId, payload, config) {
        var _this2 = this;
        var conf, url, response;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              conf = _extends(_defineProperty({}, CANCEL_KEYS, {
                getter: function getter() {
                  return _this2.createPackageLinksCancelToken;
                },
                setter: function setter(token) {
                  return _this2.createPackageLinksCancelToken = token;
                },
                clearer: function clearer() {
                  return _this2.createPackageLinksCancelToken = undefined;
                }
              }), config);
              url = "/projects/".concat(projectId, "/packages/shared:batch-create");
              _context5.next = 4;
              return this.HttpService.pkgV1.post(url, payload, conf);
            case 4:
              response = _context5.sent;
              return _context5.abrupt("return", response.data || {});
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function createPackageSharedLinks(_x13, _x14, _x15) {
        return _createPackageSharedLinks.apply(this, arguments);
      }
      return createPackageSharedLinks;
    }()
    /**
     * Get shared file public link info
     * https://platform.stoplight.autodesk.com/docs/docs-cp/reference/ACC-Projects.yaml/paths/~1shared-link:get-info/post
     *
     * @param payload - include \{shareId, recipientId(optional)\}
     * @param config - Configurable object to overwrite request parameters
     * @returns a promise with group of links information, shape of
     *                    \{
     *                      sharedResource: object,
     *                      sharedToken: string,
     *                      tokenExpireIn: number,
     *                      projectName: string,
     *                      title: string
     *                    \}
     */
    )
  }, {
    key: "getSharedInfo",
    value: (function () {
      var _getSharedInfo = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(payload, config) {
        var url, response;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              url = "/shared-link:get-info";
              _context6.next = 3;
              return this.HttpService.dmV3.post(url, payload, config);
            case 3:
              response = _context6.sent;
              return _context6.abrupt("return", response.data ? ShareLink.parseV3(response.data) : {});
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function getSharedInfo(_x16, _x17) {
        return _getSharedInfo.apply(this, arguments);
      }
      return getSharedInfo;
    }()
    /**
     * Get group of shared files/folders link information
     * https://platform.stoplight.autodesk.com/docs/docs-cp/reference/ACC-Projects.yaml/paths/~1projects~1%7BprojectId%7D~1files~1shared~1%7BsharedGroupId%7D/get
     *
     * @param projectId - the project id
     * @param sharedGroupId - the group id of shared files/folders
     * @param params - the request params, shape of \{ recipientId: string \}
     * @param config - Configurable object to overwrite request parameters
     * @returns a promise with group of links information, shape of
     *                    \{
     *                      title: string,
     *                      message: string,
     *                      expirationDate: string,
     *                      sender: \{ name: string \},
     *                      resources: [\{ urn: string, entityType: string, name: string, version: number, size: size, description: string, mimeType: string \}]
     *                    \}
     */
    )
  }, {
    key: "getSharedGroupInfo",
    value: (function () {
      var _getSharedGroupInfo = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(projectId, sharedGroupId, params, config) {
        var query, url, response;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              query = QS.stringify(params, {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/files/shared/").concat(sharedGroupId).concat(query);
              _context7.next = 4;
              return this.HttpService.dmV3.get(url, config);
            case 4:
              response = _context7.sent;
              return _context7.abrupt("return", response.data || {});
            case 6:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function getSharedGroupInfo(_x18, _x19, _x20, _x21) {
        return _getSharedGroupInfo.apply(this, arguments);
      }
      return getSharedGroupInfo;
    }()
    /**
     * Get shared public link token for group share files(v3)
     * https://platform.stoplight.autodesk.com/docs/docs-cp/reference/ACC-Projects.yaml/paths/~1shared-link-token/post
     *
     * @param payload - include \{shareGroupId, resources([urns])\}
     * @param config - Configurable object to overwrite request parameters
     * @returns a promise with token information, shape of
     *                    \{
     *                      sharedToken: string,
     *                      expiredAt: number,
     *                      tokenExpireIn: number
     *                    \}
     */
    )
  }, {
    key: "getSharedFilesLinkToken",
    value: (function () {
      var _getSharedFilesLinkToken = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8(payload, config) {
        var response;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return this.HttpService.dmV3.post("/shared-link-token", payload, config);
            case 2:
              response = _context8.sent;
              return _context8.abrupt("return", response.data || {});
            case 4:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function getSharedFilesLinkToken(_x22, _x23) {
        return _getSharedFilesLinkToken.apply(this, arguments);
      }
      return getSharedFilesLinkToken;
    }()
    /**
     * Get shared public link token
     * https://platform.stoplight.autodesk.com/docs/docs-cp/reference/B360-Docs-V2.yaml/paths/~1shared-link-token/post
     *
     * @param payload - include \{shareId, resource(urn)\}
     * @param config - Configurable object to overwrite request parameters
     * @returns a promise with token information, shape of
     *                    \{
     *                      sharedToken: string,
     *                      tokenExpireIn: number
     *                    \}
     */
    )
  }, {
    key: "getSharedLinkToken",
    value: (function () {
      var _getSharedLinkToken = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9(payload, config) {
        var response;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return this.HttpService.dmV2.post("/shared-link-token", payload, config);
            case 2:
              response = _context9.sent;
              return _context9.abrupt("return", response.data ? ShareLink.tokenParseV2(response.data) : {});
            case 4:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function getSharedLinkToken(_x24, _x25) {
        return _getSharedLinkToken.apply(this, arguments);
      }
      return getSharedLinkToken;
    }()
    /**
     * Get sheet shared status
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/reference/ACC-Sheets-Share-Link.yaml/paths/~1projects~1%7BprojectId%7D~1sheets~1shared-status:check/post
     *
     * @param projectId - the project id
     * @param payload - the request body, containing list of sheets id, shape of \{ resources \}
     * @param config - Configurable object to overwrite request parameters.
     * @returns a promise with results and errors, shape of
     *                    \{
     *                      results: [\{ shared: boolean, id: string \}],
     *                      errors: [\{ id: string, code: string, title: string, detail: string \}]
     *                    \}
     */
    )
  }, {
    key: "getSheetSharedStatus",
    value: (function () {
      var _getSheetSharedStatus = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee10(projectId, payload, config) {
        var url, response;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              url = "/projects/".concat(projectId, "/sheets/shared-status:check");
              _context10.next = 3;
              return this.HttpService.dmV3.post(url, payload, config);
            case 3:
              response = _context10.sent;
              return _context10.abrupt("return", response.data || {});
            case 5:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function getSheetSharedStatus(_x26, _x27, _x28) {
        return _getSheetSharedStatus.apply(this, arguments);
      }
      return getSheetSharedStatus;
    }()
    /**
     * Delete all related records for given resources
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/reference/ACC-Sheets-Share-Link.yaml/paths/~1projects~1%7BprojectId%7D~1shared:batch-delete/post
     *
     * @param projectId - the project id
     * @param payload - the request body, shape of \{ resources: string[], resourceType: 'Sheet|SheetHistory' \}
     * @param config - Configurable object to overwrite request parameters.
     * @returns a promise with results and errors, shape of
     *                    \{
     *                      results: [\{ id: string \}],
     *                      errors: [\{ id: string, title: string, detail: string, code: string \}
     *                    \}
     */
    )
  }, {
    key: "deleteSheetSharedLinks",
    value: (function () {
      var _deleteSheetSharedLinks = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee11(projectId, payload, config) {
        var url, response;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              url = "/projects/".concat(projectId, "/shared:batch-delete");
              _context11.next = 3;
              return this.HttpService.dmV3.post(url, payload, config);
            case 3:
              response = _context11.sent;
              return _context11.abrupt("return", response.data || {});
            case 5:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function deleteSheetSharedLinks(_x29, _x30, _x31) {
        return _deleteSheetSharedLinks.apply(this, arguments);
      }
      return deleteSheetSharedLinks;
    }()
    /**
     * Create sheet shared links
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/reference/ACC-Sheets-Share-Link.yaml/paths/~1projects~1%7BprojectId%7D~1sheets~1shared:batch-create/post
     *
     * @param projectId - the project id
     * @param payload - the resources to create link, shape or
     *                          \{
     *                            type: 'Public'|'AccountDirectory',
     *                            resources: string[],
     *                            markupOption: \{ includePublicMarkups: boolean, includePrivateMarkups: boolean \}
     *                            recipients: \{emails?: string[], userIds?: string[], companyOxygenIds?: string[], roleOxygenIds?:string[]\}
     *                            title: string,
     *                            message: string,
     *                            expirationDate: string
     *                          \}
     * @param config - Configurable object to overwrite request parameters
     * @returns a promise with shared links, shape of
     *                    \{
     *                      shareId: string,
     *                      links: \{
     *                        resource: string,
     *                        link: string,
     *                        name: string,
     *                        versionSet: \{ id: string, name: string, issuanceDate: string\}
     *                        collection: \{ id: string, name: string, type: string\}
     *                      \}[]
     *                    \}
     */
    )
  }, {
    key: "createSheetSharedLinks",
    value: (function () {
      var _createSheetSharedLinks = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee12(projectId, payload, config) {
        var _this3 = this;
        var conf, product, rest, query, url, response;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              conf = _extends(_defineProperty({}, CANCEL_KEYS, {
                getter: function getter() {
                  return _this3.createSheetLinksCancelToken;
                },
                setter: function setter(token) {
                  return _this3.createSheetLinksCancelToken = token;
                },
                clearer: function clearer() {
                  return _this3.createSheetLinksCancelToken = undefined;
                }
              }), config);
              product = payload.product, rest = _objectWithoutProperties(payload, _excluded);
              query = QS.stringify({
                product: product
              }, {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/sheets/shared:batch-create").concat(query);
              _context12.next = 6;
              return this.HttpService.dmV3.post(url, rest, conf);
            case 6:
              response = _context12.sent;
              return _context12.abrupt("return", response.data || {});
            case 8:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function createSheetSharedLinks(_x32, _x33, _x34) {
        return _createSheetSharedLinks.apply(this, arguments);
      }
      return createSheetSharedLinks;
    }()
    /**
     * Create export job for exporting shared sheets
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/reference/ACC-Sheets-Share-Link.yaml/paths/~1projects~1%7BprojectId%7D~1sheets~1shared~1resources~1export/post
     *
     * @param projectId - the project id
     * @param recipientId - the recipient id
     * @param payload - the request body, shape of \{ resources: string[], outputFileName: string \}
     * @param config - Configurable object to overwrite request parameters
     * @returns a promise with sheet export jobId (UUID), shape of \{ jobId: string \}
     */
    )
  }, {
    key: "exportSheetSharedLinks",
    value: (function () {
      var _exportSheetSharedLinks = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee13(projectId, recipientId, payload, config) {
        var query, url, response;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              query = QS.stringify({
                recipientId: recipientId
              }, {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/sheets/shared/resources/export").concat(query);
              _context13.next = 4;
              return this.HttpService.dmV3.post(url, payload, config);
            case 4:
              response = _context13.sent;
              return _context13.abrupt("return", response.data || {});
            case 6:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function exportSheetSharedLinks(_x35, _x36, _x37, _x38) {
        return _exportSheetSharedLinks.apply(this, arguments);
      }
      return exportSheetSharedLinks;
    }()
    /**
     * Get shared sheets export job status
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/reference/ACC-Sheets-Share-Link.yaml/paths/~1projects~1%7BprojectId%7D~1sheets~1shared~1export-jobs~1%7Bid%7D/get
     *
     * @param projectId - the project id
     * @param jobId - the job id
     * @param config - Configurable object to overwrite request parameters
     * @returns a promise with export job status, shape of
     *                    \{
     *                      result: \{ output: \{ signedUrl: string \}, error: \{ code: string, title: string, detail: string \} \}
     *                      status: 'successful|processing|failed'
     *                    \}
     */
    )
  }, {
    key: "getExportSheetSharedLinkStatus",
    value: (function () {
      var _getExportSheetSharedLinkStatus = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee14(projectId, jobId, config) {
        var url, response;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              url = "/projects/".concat(projectId, "/sheets/shared/export-jobs/").concat(jobId);
              _context14.next = 3;
              return this.HttpService.dmV3.get(url, config);
            case 3:
              response = _context14.sent;
              return _context14.abrupt("return", response.data || {});
            case 5:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
      function getExportSheetSharedLinkStatus(_x39, _x40, _x41) {
        return _getExportSheetSharedLinkStatus.apply(this, arguments);
      }
      return getExportSheetSharedLinkStatus;
    }()
    /**
     * Get shared sheet link information
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/reference/ACC-Sheets-Share-Link.yaml/paths/~1projects~1%7BprojectId%7D~1sheets~1shared~1resources~1%7BlinkId%7D/get
     *
     * @param projectId - the project id
     * @param linkId - the shared link id
     * @param config - Configurable object to overwrite request parameters
     * @returns a promise with link information, shape of
     *                    \{
     *                      expirationDate: string,
     *                      sheet: \{
     *                        id: string, name: string, versionSet: \{ id: string, name: string, issuanceDate: string \},
     *                        collection: \{ id: string, name: string, type: string \}
     *                      \}
     *                    \}
     */
    )
  }, {
    key: "getSharedSheetInfo",
    value: (function () {
      var _getSharedSheetInfo = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee15(projectId, linkId, config) {
        var url, response;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              url = "/projects/".concat(projectId, "/sheets/shared/resources/").concat(linkId);
              _context15.next = 3;
              return this.HttpService.dmV3.get(url, config);
            case 3:
              response = _context15.sent;
              return _context15.abrupt("return", response.data || {});
            case 5:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
      function getSharedSheetInfo(_x42, _x43, _x44) {
        return _getSharedSheetInfo.apply(this, arguments);
      }
      return getSharedSheetInfo;
    }()
    /**
     * Get group of shared sheet links information
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/reference/ACC-Sheets-Share-Link.yaml/paths/~1projects~1%7BprojectId%7D~1sheets~1shared~1%7BsharedGroupId%7D/get
     *
     * @param projectId - the project id
     * @param groupId - the group id of shared sheets
     * @param params - the request params, shape of \{ recipientId: string \}
     * @param config - Configurable object to overwrite request parameters
     * @returns a promise with group of links information, shape of
     *                    \{
     *                      title: string,
     *                      message: string,
     *                      expirationDate: string,
     *                      shareCount: integer,
     *                      sheets: [\{ id: string, resourceId: string, name: string, versionSet: object, isCurrent: boolean, collection: \{ id: string, name: string, type: string \} \}]
     *                    \}
     */
    )
  }, {
    key: "getSharedSheetsGroupInfo",
    value: (function () {
      var _getSharedSheetsGroupInfo = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee16(projectId, groupId, params, config) {
        var query, url, response;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              query = QS.stringify(params, {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/sheets/shared/").concat(groupId).concat(query);
              _context16.next = 4;
              return this.HttpService.dmV3.get(url, config);
            case 4:
              response = _context16.sent;
              return _context16.abrupt("return", response.data || {});
            case 6:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this);
      }));
      function getSharedSheetsGroupInfo(_x45, _x46, _x47, _x48) {
        return _getSharedSheetsGroupInfo.apply(this, arguments);
      }
      return getSharedSheetsGroupInfo;
    }()
    /**
     * Create share by project bridge file package
     * https://platform.stoplight.autodesk.com/docs/bridge/f13cc8b650b07-create-a-v-1-file-package
     * https://wiki.autodesk.com/pages/viewpage.action?pageId=947978199
     *
     * @param params - the request params, shape of
     *                    \{
     *                      sourceProjectId: string,
     *                      targetProjectIds: string[],
     *                      receiverEmails: string[],
     *                      assets: \{ [assetType]: \{ uid: string, snapshotId?: string \}[] \}, // assetType could be 'sheet'
     *                      hasMoreData: boolean,
     *                      filePackageType: string // ENUM: 'to_self', 'for_review'. Note: when "for_review" is used, the targetFolderId must not be sent
     *                      filePackageName: string
     *                    \}
     * @param config - Configurable object to overwrite request parameters
     * @returns a promise with file package id, shape of \{ filePackageId: string \}
     */
    )
  }, {
    key: "shareByProjectBridge",
    value: (function () {
      var _shareByProjectBridge = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee17(params, config) {
        var payload, res;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              payload = _extends({
                hasMoreData: false,
                filePackageType: params.filePackageType || 'to_self'
              }, params);
              _context17.next = 3;
              return this.HttpService.paddV1.post('/file-package', payload, config);
            case 3:
              res = _context17.sent;
              return _context17.abrupt("return", res.data || {});
            case 5:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this);
      }));
      function shareByProjectBridge(_x49, _x50) {
        return _shareByProjectBridge.apply(this, arguments);
      }
      return shareByProjectBridge;
    }()
    /**
     * Accept file package by receiver
     * https://platform.stoplight.autodesk.com/docs/bridge/5b1d73f6a2506-create-a-v-1-transaction
     *
     * @param params - request params, shape of
     *                    \{
     *                      targetProjectId: string,
     *                      assets: \{ [assetType]: \{ uid: string \}[] \}, // assetType could be 'sheet'
     *                      exportId: string,
     *                      hasMoreData: boolean,
     *                      transactionName: string
     *                    \}
     * @param config - Configurable object to overwrite request parameters
     * @returns a promise with transaction id, shape of \{ transactionId: string \}
     */
    )
  }, {
    key: "sharePublicLinkByProjectBridge",
    value: (function () {
      var _sharePublicLinkByProjectBridge = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee18(params, config) {
        var payload, res;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              payload = _extends({
                hasMoreData: false
              }, params);
              _context18.next = 3;
              return this.HttpService.paddV1.post('/transaction', payload, config);
            case 3:
              res = _context18.sent;
              return _context18.abrupt("return", res.data || {});
            case 5:
            case "end":
              return _context18.stop();
          }
        }, _callee18, this);
      }));
      function sharePublicLinkByProjectBridge(_x51, _x52) {
        return _sharePublicLinkByProjectBridge.apply(this, arguments);
      }
      return sharePublicLinkByProjectBridge;
    }()
    /**
     * Get the automation a project
     * https://platform.stoplight.autodesk.com/docs/bridge/8b20f86c3d640-list-v-1-automations
     *
     * @param params - the request params, shape of
     *                    \{
     *                       sourceProjectId: string,
     *                       targetProjectId: string,
     *                       assetType: string,
     *                       nextSyncToken: string
     *                    \}
     * @param config - Configurable object to overwrite request parameters
     * @returns a promise object which contains automations
     */
    )
  }, {
    key: "getAutomations",
    value: (function () {
      var _getAutomations = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee19(params, config) {
        var _this4 = this,
          _response$data,
          _response$data2,
          _response$data3;
        var conf, query, response;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              conf = _extends(_defineProperty({}, CANCEL_KEYS, {
                getter: function getter() {
                  return _this4.automationsCacnelToken;
                },
                setter: function setter(token) {
                  return _this4.automationsCacnelToken = token;
                },
                clearer: function clearer() {
                  return _this4.automationsCacnelToken = undefined;
                }
              }), config);
              query = QS.stringify({
                source_project_id: params === null || params === void 0 ? void 0 : params.sourceProjectId,
                target_project_id: params === null || params === void 0 ? void 0 : params.targetProjectId,
                asset_type: params === null || params === void 0 ? void 0 : params.assetType,
                sync_token: params === null || params === void 0 ? void 0 : params.nextSyncToken
              }, {
                addQueryPrefix: true
              });
              _context19.next = 4;
              return this.HttpService.paddV1.get("/automations".concat(query), conf);
            case 4:
              response = _context19.sent;
              return _context19.abrupt("return", {
                data: (((_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.data) || []).map(AutomationItem.parseV1),
                nextSyncToken: (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.next_sync_token,
                moreData: !!((_response$data3 = response.data) !== null && _response$data3 !== void 0 && _response$data3.more_data)
              });
            case 6:
            case "end":
              return _context19.stop();
          }
        }, _callee19, this);
      }));
      function getAutomations(_x53, _x54) {
        return _getAutomations.apply(this, arguments);
      }
      return getAutomations;
    }()
    /**
     * Get the all automations a project
     * https://platform.stoplight.autodesk.com/docs/bridge/8b20f86c3d640-list-v-1-automations
     *
     * @param params - the request params, shape of
     *                    \{
     *                       sourceProjectId: string,
     *                       targetProjectId: string,
     *                       assetType: string,
     *                       nextSyncToken: string,
     *                       fields: string, for multiple fields, separate each field by comma
     *                    \}
     * @param config - Configurable object to overwrite request parameters
     * @returns a promise object which contains all automations
     */
    )
  }, {
    key: "getAllAutomations",
    value: (function () {
      var _getAllAutomations = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee20(params, config) {
        var data, nextSyncToken, moreData, _response$data4, _response$data5, _response$data6, query, response;
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              data = [];
              nextSyncToken = params === null || params === void 0 ? void 0 : params.nextSyncToken;
              moreData = true;
            case 3:
              if (!moreData) {
                _context20.next = 13;
                break;
              }
              query = QS.stringify({
                source_project_id: params === null || params === void 0 ? void 0 : params.sourceProjectId,
                target_project_id: params === null || params === void 0 ? void 0 : params.targetProjectId,
                asset_type: params === null || params === void 0 ? void 0 : params.assetType,
                sync_token: nextSyncToken,
                fields: params === null || params === void 0 ? void 0 : params.fields
              }, {
                addQueryPrefix: true
              });
              _context20.next = 7;
              return this.HttpService.paddV1.get("/automations".concat(query), config);
            case 7:
              response = _context20.sent;
              Array.prototype.push.apply(data, ((_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.data) || []);
              nextSyncToken = (_response$data5 = response.data) === null || _response$data5 === void 0 ? void 0 : _response$data5.next_sync_token;
              moreData = !!((_response$data6 = response.data) !== null && _response$data6 !== void 0 && _response$data6.more_data);
              _context20.next = 3;
              break;
            case 13:
              return _context20.abrupt("return", {
                data: data.map(AutomationItem.parseV1),
                nextSyncToken: nextSyncToken,
                moreData: false
              });
            case 14:
            case "end":
              return _context20.stop();
          }
        }, _callee20, this);
      }));
      function getAllAutomations(_x55, _x56) {
        return _getAllAutomations.apply(this, arguments);
      }
      return getAllAutomations;
    }()
    /**
     * get bridges for a given project V2(offset based)
     * https://platform.stoplight.autodesk.com/docs/bridge/41df8471f480f-list-v-2-bridges
     *
     * @param params - the query parameter options contains filter: \{ status, projectId \}, fields, offset and limit.
     * @param config - Configurable object to overwrite request parameters
     * @returns a promise with bridged projects list
     */
    )
  }, {
    key: "getBridgedProjects",
    value: (function () {
      var _getBridgedProjects = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee21() {
        var params,
          config,
          query,
          response,
          _args21 = arguments;
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              params = _args21.length > 0 && _args21[0] !== undefined ? _args21[0] : {};
              config = _args21.length > 1 ? _args21[1] : undefined;
              query = QS.stringify(_extends({
                limit: 100,
                offset: 0
              }, params), {
                addQueryPrefix: true,
                encodeValuesOnly: true,
                arrayFormat: 'comma'
              });
              _context21.next = 5;
              return this.HttpService.paddV2.get("/bridges".concat(query), config);
            case 5:
              response = _context21.sent;
              return _context21.abrupt("return", response.data || {});
            case 7:
            case "end":
              return _context21.stop();
          }
        }, _callee21, this);
      }));
      function getBridgedProjects() {
        return _getBridgedProjects.apply(this, arguments);
      }
      return getBridgedProjects;
    }())
  }], [{
    key: "getName",
    value: function getName() {
      return 'Share';
    }
  }]);
}(Base);
export default Share;